import { TotalModeEnum } from '@e-socna/data-layer';

const TOTAL_MODE_LABELS: Readonly<Record<TotalModeEnum, string>> = {
  [TotalModeEnum.Automatic]: 'Mode automatique',
  [TotalModeEnum.Manual]: 'Mode manuel',
};

export function formatTotalMode(
  totalMode: TotalModeEnum | null | undefined,
): string | undefined {
  return totalMode ? TOTAL_MODE_LABELS[totalMode] : undefined;
}
